<template>
  <div class="row">
    <div class="col-md-12">
      <div class="category-top-bar">
        <div class="top-bar">
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </div>
      </div>
      <p class="clearfix"></p>
      <automation-campaign-form :route="route"></automation-campaign-form>
    </div>
  </div>
</template>
<script>
  import AutomationCampaignForm from './AutomationCampaignForm.vue'
  // used for both /marketing/automation/add and /marketing/automation/edit/:id
  export default {
    components: {
      AutomationCampaignForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/AutomationCampaigns/AutomationCampaignPage.vue